import React from 'react';
import { Trans } from 'react-i18next';
import { Paragraph } from '@staffino/flow-controls';
import { styled } from '@staffino/primitive-controls';
import {
  space,
  layout,
  flexbox,
  SpaceProps,
  LayoutProps,
  FlexboxProps,
} from 'styled-system';
import { StyledComponent } from '@emotion/styled';

type StyledFooterProps = SpaceProps & LayoutProps & FlexboxProps;
const StyledFooter: StyledComponent<StyledFooterProps> = styled.footer(
  () => ({
    margin: 'auto',
  }),
  space,
  layout,
  flexbox,
);

type Props = {
  color?: string;
  children?: React.ReactNode | React.ReactNodeArray;
} & StyledFooterProps;
const Footer = ({ color, children, ...props }: Props) => (
  <StyledFooter {...props}>
    <img
      src={`/public/images/staffino-${color.toLowerCase()}.svg`}
      width="62"
      height="14"
      alt="Staffino"
    />
    <Paragraph color={color}>
      <Trans>Independent feedback system</Trans>
    </Paragraph>
    {children}
  </StyledFooter>
);

export default Footer;
